export const TEXT = {
  CHECKOUT_MESSAGE: {id: 'mylk.nba.ps.message.checkout'},
  CHECKOUT_CTA: {id: 'mylk.nba.checkout.cta'},
};
